<template>
    <div class="jr-component">
      <span class="jr-display-name">
        <span v-if="components.controlMustfilled && components.controlDisplayname != ''" class="jr-must-filled-ico">*</span>
        <span >{{ components.controlDisplayname }}</span>
      </span>
      <el-select :class="{'jr-select' : true, 'jr-checkinput' : $v.inputValue.$error && components.controlMustfilled}" @blur="$v.inputValue.$touch()" v-bind="$attrs" :id="components.controlId" :size="size" v-model="inputValue" :disabled="!components.controlRighttype || components.controlReadonly" clearable filterable placeholder="请选择">
        <template v-if="selectDataParam !== undefined"><el-option v-for="(item, i) in selectData" :key="i" :label="item[selectDataParam.label]" :value="item[selectDataParam.value]"></el-option></template>
        <template v-if="selectDataParam === undefined"><el-option v-for="(item, i) in selectData" :key="i" :label="item" :value="i"></el-option></template>
        
      </el-select>
      <i @click="rightClick" v-if="badge & components.controlRighttype" class="el-icon-success jr-right-ico" style="color: green;"/>
      <i @click="rightClick" v-if="badge & !components.controlRighttype" class="el-icon-error jr-right-ico" style="color: red;"/>          
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'JrSelect',
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  props: {
    value: {},
    badge: {
      type: Boolean,
      default: false
    },
    components: {},
    selectData: {},
    selectDataParam: {},
    size: {
      type: String,
      default: 'small'
    }
    
  },
  methods: {
    rightClick(){
      this.$emit('badge-click', this.components.controlId, !this.components.controlRighttype)
    }
  },
  //输入校验
  validations: {
    inputValue: {
      required
    }
  }
}

</script>
<style scoped lang="scss">
  .jr-display-name{
    width: 120px;
    text-align: right;
    vertical-align: middle;
    padding-right: 10px;
    color: #676767;
    display: inline-block; 
  }
  .jr-must-filled-ico{
    width: 10px;
    text-align: center;
    vertical-align: middle;
    font-size: 18px;
    color: red;
    display:inline-block; 
  }
  .jr-select{
    width: 190px;
  }
  
  

</style>


// WEBPACK FOOTER //
// src/components/componentsjr/JrSelect.vue